'use strict';

angular.module('formonlineApp').service('IframeService', ['$timeout',
    function ($timeout) {

        this.sendHeightToParent = function(idDiv) {
            $timeout(function() {
                var height = document.getElementById(idDiv).offsetHeight;
                parent.postMessage({ scrollHeight: height }, '*');
            }, 250);
        }

    }]);
